import React from 'react';
import ChatApp from './ChatThread/ChatApp';
import PageHeader from '@/app/customComponents/PageHeader';
import { useNavigate } from 'react-router-dom';
const MessagingThread = () => {
	const navigate = useNavigate();
	const goBack = () => {
		navigate(-1);
	};
	return (
		<div className="pt-32">
			<div className="px-16">
				<PageHeader onBack={goBack} title="Chat" />
			</div>
			<ChatApp />
		</div>
	);
};

export default MessagingThread;
